module.exports = __webpack_public_path__ + "static/media/13d.dc58368f.svg";